"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _GoogleMap = _interopRequireDefault(require("./components/GoogleMap"));
var _constants = require("../constants");
var _MapCard = _interopRequireDefault(require("./components/MapCard"));
var _hooks = require("../../helpers/hooks");
var _MediaContext = require("../MediaContext/MediaContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DestinationMap = function DestinationMap(_ref) {
  var days = _ref.days,
    title = _ref.title,
    dark = _ref.dark;
  var _useState = (0, _react.useState)({
      selectedIndex: 0,
      wrapperWidth: null
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var width = (0, _hooks.useWindowWidth)();
  var mapWrapperEl = (0, _react.useRef)(null);
  var mapWrapperWidth = mapWrapperEl.current && mapWrapperEl.current.offsetWidth;
  var updateActiveDay = function updateActiveDay(index) {
    return setState(_objectSpread(_objectSpread({}, state), {}, {
      selectedIndex: index
    }));
  };
  var selectedDay = days[state.selectedIndex];
  var markers = days.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      title: d.title && d.title.rendered
    });
  });
  return /*#__PURE__*/_react["default"].createElement("section", {
    ref: mapWrapperEl,
    className: "d8-c-destination-map margin-right-xxl@lg"
  }, title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-center padding-top-lg padding-top-0@md margin-bottom-lg text-xl d8-u-ls-sm"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "google-map aspect-16-9"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "google-map__wrapper aspect-16-9"
  }, " ", /*#__PURE__*/_react["default"].createElement(_GoogleMap["default"], {
    mapWrapperWidth: mapWrapperWidth,
    selectedIndex: state.selectedIndex,
    markers: markers,
    updateActiveDay: updateActiveDay,
    dark: dark,
    isMobile: width < _constants.BREAKPOINTS.MD
  })), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.MD
  }, days && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-container max-width-xxs margin-auto"
  }, /*#__PURE__*/_react["default"].createElement(_MapCard["default"], {
    days: days,
    selectedDay: selectedDay,
    selectedIndex: state.selectedIndex,
    updateActiveDay: updateActiveDay
  })))), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.MD
  }, days && /*#__PURE__*/_react["default"].createElement(_MapCard["default"], {
    days: days,
    selectedDay: selectedDay,
    selectedIndex: state.selectedIndex,
    updateActiveDay: updateActiveDay
  })));
};
DestinationMap.propTypes = {
  days: _propTypes["default"].array,
  title: _propTypes["default"].string,
  dark: _propTypes["default"].bool
};
DestinationMap.defaultProps = {
  days: [],
  title: '',
  dark: false
};
var _default = exports["default"] = DestinationMap;